import * as Redux from 'redux'
import * as Request from '../../request'
import * as Modal from '../modal'
import * as Constants from './constants'
import * as Types from './types'

// upload the image, and carry along data from the requestor
// so the responding reducer can choose to update some state.
export const uploadImage = (event: string) =>
  (community: string, imageData: Types.ModalImageData) => {
  return Request.requestActionCreator(event)
    ({
      method: 'POST',
      payload: {
        content: imageData.content,
        name: imageData.name,
        partnerCode: imageData.partnerCode,
        rowId: imageData.rowId,
      },
      url: `${Constants.IMAGE_IMPORT_SERVER_RESOURCE}/${community}`,
    })
}

export interface OpenModalAction extends Redux.Action { partnerCode?: string, rowId?: string }
export type OpenModalActionCreator = (partnerCode?: string, rowId?: string) => OpenModalAction

export const openModal = (event: string): OpenModalActionCreator =>
  (partnerCode: string, rowId: string) =>
  ({
    partnerCode,
    rowId,
    type: Modal.toggleModalConstant(event),
  })



// WEBPACK FOOTER //
// ./src/components/image/actions.ts